import React from 'react'
import { useSelector } from 'react-redux'
import { TenantEditSlice, MSATenantConfigSlice } from '../../../../reducers'
import { FormGroup, FormControlLabel, Checkbox, Typography, Box } from '@mui/material'

const PermissionsList = ({ setValue, features }) => {
  const msaActive = useSelector(TenantEditSlice.selectors.msaActive)
  const msaConfig = useSelector(MSATenantConfigSlice.selectors.selectTenantMSAConfig)

  const handleChange = (event) => {
    features[event.target.name] = event.target.checked
    setValue('features', features)
  }

  return (
    <FormGroup sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }} data-test='permissions-upload-permissions-list'>
      {msaActive && (
        <Box display='flex' flexDirection='column'>
          <FormControlLabel control={<Checkbox checked={(msaActive && msaConfig.seatsAvailable > 0)} disabled />} label='Manager Skills Assessments' onChange={handleChange} name='msa:access' data-test='upload-permissions-msa' />
          <Typography variant='caption' color='textSecondary' data-test='upload-permissions-msa-seats-total'>
            Total Seats: {msaConfig.numberOfUsers}
          </Typography>
          <Typography variant='caption' color='textSecondary' data-test='upload-permissions-msa-seats-available'>
            Seats Available: {msaConfig.seatsAvailable}
          </Typography>
        </Box>
      )}
      {/* <FormControlLabel control={<Checkbox />} label='Playlists' onChange={handleChange} name='playlists' />
      <FormControlLabel control={<Checkbox />} label='Reporting' onChange={handleChange} name='reporting' /> */}
    </FormGroup>
  )
}

export default PermissionsList
